<ng-template ngFor let-breadcrumb [ngForOf]="breadcrumbs" let-last = last>
  <li class="breadcrumb-item"
      *ngIf="breadcrumb.label.title||last"
      [ngClass]="{active: last}">
    <a *ngIf="!last" [routerLink]="breadcrumb.url" translate>{{breadcrumb.label.title}}</a>
    <span *ngIf="last" [routerLink]="breadcrumb.url" translate>{{breadcrumb.label.title}}</span>
  </li>
</ng-template>
